<template>
  <div class="filterItemOptionContainer nav-vertical__item flex-wrap py-0">
    <div class="nav-vertical__content">
      <input
        :checked="active && !disabled ? 'checked' : ''"
        @input="onInput"
        class="mr-2 w-auto cursor-pointer filterItemRadioButton"
        :class="{ disabled }"
        type="radio"
        :name="name"
        :disabled="disabled"
        :value="value"
        :id="radioButtonId"
      />
      <label :for="radioButtonId">
        {{ text }} 
        <span class="alignright">({{ count || 0 }} 
          <div class="screenreader-only">results</div>
          )</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    ariaLabel: String,
    disabled: Boolean,
    count: [Number, String],
    name: { required: true, type: String },
    text: { required: true, type: String },
    title: { required: true, type: String },
    value: { required: true, type: [Number, String, Boolean] },
  },
  data: () => ({ on: false }),
  computed: {
    radioButtonId() {
      return `FilterItemRadioButton${this.value}`
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', { active: e?.target?.checked, value: this.value })
    },
  },
}
</script>

<style lang="scss" scoped>
.filterItemOptionContainer,
.filterItemOptionContainer label {
  width: 100%;
}
.nav-vertical__item {
  padding-right: 0 !important;
}
.alignright {
  float: right;
}
.screenreader-only {
position:absolute;
left:-10000px;
top:auto;
width:1px;
height:1px;
overflow:hidden;
}
</style>
